import React from 'react';

import { getFallbackLocale } from '../../../i18n';
import { LabelName, LabelType } from './types';
import { locale } from '../../../config';
import { DeveloperContactButton } from '../ContactDeveloper/index';
import { DeveloperContactLink } from '../ContactDeveloper/ContactLink';
import Typography from '../Typography';

export const LABELS: LabelType[] = [
  {
    shouldDisplay: (app) => app.hasNoVersionAvailable && !app.availableForDevice,
    translationKey: () => 'cannotInstallNotice',
    name: LabelName.CANNOT_INSTALL,
  },
  {
    shouldDisplay: (app) => app.hasNoVersionAvailable && app.availableForDevice,
    translationKey: () => 'cannotInstallNoticeNoVersion',
    labelMessage: ({ message, link }) => {
      const href = `https://help.fitbit.com/articles/en_US/Help_article/1871/?l=${getFallbackLocale(
        locale
      ).replace('-', '_')}`;

      return (
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          {message}{' '}
          <a href={href}>
            {link}
          </a>
        </Typography>
      );
    },
    name: LabelName.CANNOT_INSTALL_NO_VERSION_AVAILABLE,
  },
  {
    shouldDisplay: (app) => {
      if (!app.hasNoVersionAvailable) {
        if (app.isRestrictedForUserRegion()) {
          return true;
        }

        if (app.cannotInstallOnDevice) {
          return true;
        }
      }
      return false;
    },
    translationKey: (app) => {
      if (!app.hasNoVersionAvailable) {
        if (app.isRestrictedForUserRegion()) {
          return 'cannotInstallNoticeNoRegion';
        }

        if (app.cannotInstallOnDevice) {
          return 'cannotInstallNoticeDeviceDisconnected';
        }
      }
      return '';
    },
    name: LabelName.CANNOT_INSTALL_REGION_VERSION,
  },
  {
    shouldDisplay: (app) => app.compatibilityMode,
    translationKey: () => 'compatibility',
    labelMessage: ({ message, link }, app, { phoneAppVersion, deviceName }) => (
      <>
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          {message}
          <DeveloperContactButton
          id='DeveloperContactButton'
          app={app}
            phoneAppVersion={phoneAppVersion}
            label={link as string}
            showLabel={true}
            deviceName={deviceName}
            LinkComponent={DeveloperContactLink}
          />
        </Typography>

      </>
    ),
    name: LabelName.COMPATIBILITY,
  },
  {
    shouldDisplay: (app) => app.isPaid,
    translationKey: () => 'paid',
    name: LabelName.PAID,
  },
];